import { useTranslation } from 'react-i18next'
import { Dropdown, Menu } from 'antd'
import { useLanguage } from '../../contexts/langContext'
import { LanguageEnum } from '../../until/constant'
import earth from '../../assets/images/earth.png'
import styles from './index.module.scss'

import type { MenuInfo } from 'rc-menu/lib/interface'

const LanguageSelector = () => {
  const { t, i18n } = useTranslation()
  const { lang, setLang } = useLanguage()

  const handleMenuClick = (e: MenuInfo) => {
    const selectedLang = e.key as LanguageEnum
    i18n.changeLanguage(selectedLang)
    setLang(selectedLang)
  }

  const listLang = [
    { label: t('language.japanese'), value: LanguageEnum.JAPANESE },
    { label: t('language.english'), value: LanguageEnum.ENGLISH },
  ]

  const menu = (
    <Menu
      onClick={handleMenuClick}
      selectedKeys={[lang]}
      items={listLang.map((item) => ({
        key: item.value,
        label: item.label,
      }))}
      className={styles.langDropdownMenu}
    />
  )

  const currentLangLabel = lang === LanguageEnum.JAPANESE ? t('language.japanese') : t('language.english')
  return (
    <div className={styles.languageSelectorWrapper}>
      <Dropdown overlay={menu} trigger={['click']}>
        <a onClick={(e) => e.preventDefault()} className={styles.dropdownTrigger}>
          <img src={earth} alt="earth" className={styles.earthIcon} />
          <span className={styles.langLabel}>{currentLangLabel}</span>
        </a>
      </Dropdown>
    </div>
  )
}

export default LanguageSelector
